export const loadFlickity = require('bundle-loader?lazy&name=flickity!flickity');
export const loadYoutube = require('bundle-loader?lazy&name=[name]!youtube-player');
export const loadVimeo = require('bundle-loader?lazy&name=[name]!@vimeo/player');
export const loadFuse = require('bundle-loader?lazy&name=Fuse!fuse.js');
